import type { AxiosResponse } from "axios";

import { AuthClient } from "api";
import { getAuthenticatedUserQueryKey } from "api/hooks/useGetAuthenticatedUserQuery";
import { cacheClient } from "cacheClient";
import { setAuthCookies } from "utils/cookie";

interface FormData {
  readonly email: string;
  readonly password: string;
}

interface AuthenticationResponse {
  readonly success: boolean;
  readonly result: {
    readonly id_token: string;
    readonly refresh_token: string;
    readonly expires_in: number;
  };
}

export const authenticateWithEmail = async (body: FormData): Promise<void> => {
  const response: AxiosResponse<AuthenticationResponse> = await AuthClient.post("/sign_in", {
    username: body.email,
    password: body.password,
  });

  setAuthCookies({
    idToken: response.data.result.id_token,
    refreshToken: response.data.result.refresh_token,
  });

  // Ensure the the query is refetched to get the latest user data in ProtectedRoute
  await cacheClient.refetchQueries(getAuthenticatedUserQueryKey());
};
